import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { commanderForm, presence, TextareaField, validation } from '@mews-commander/legacy-form';
import { addResources } from '../../../actions/resources';
import { stopEntityAdding } from '../../../../entityManagement/actions';

const ResourceBulkAddForm = () => (
    <TextareaField label={<LocalizedText textKey={TextKey.PasteSpaceNames} />} name="result" required />
);

const constraints = {
    result: { presence },
};

export default compose(
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    connect(undefined, (dispatch, { scope }) => ({
        onSubmit: ({ result }: $TSFixMe) => {
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
            dispatch(addResources({ result }));
            dispatch(stopEntityAdding(scope));
        },
    })),
    commanderForm({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Create} />,
        validate: validation(constraints),
    })
)(ResourceBulkAddForm);
